import * as React from "react";
import "styles/customOrderList.scss";
import CustomOrderListSearchForm from './CustomOrderListSearchForm'
import CustomOrderListTable from './CustomOrderListTable'
class CustomOrderList extends React.Component<any, any> {

  constructor(params:any) {
    super(params);
  }

  
  componentWillMount () {
    this.props.getCustomMasterList(); //初始化搜索表单sku下拉项
    this.props.customOrderListSearchFormQuery();
  }

  goToCreateOrderPage = () => {
    this.props.history.push('/app/customOrder');
  }
  
  editRow = (record) => {
    this.props.editRow(record);
    this.props.history.push('/app/customOrder?number=' + record.number);
  }
  render() {
    return (
      <div className="customOrderListContianer">
        <CustomOrderListSearchForm
          masterList={this.props.masterList}
          page={this.props.page}
          customOrderListSearchFormQuery={this.props.customOrderListSearchFormQuery}
          goToCreateOrderPage={this.goToCreateOrderPage}
          statistics={this.props.statistics}
          exportCustomOrderList={this.props.exportCustomOrderList}
          resetQueryParamsAndQuery={this.props.resetQueryParamsAndQuery}
          updateExportProcess={this.props.updateExportProcess}
        >
        </CustomOrderListSearchForm>
        <CustomOrderListTable
          queryResult={this.props.queryResult}
          page={this.props.page}
          onShowSizeChange={(current, size) => {
            this.props.onShowSizeChange({current,size})
          }}
          onChange={(page, pageSize)=>{
            this.props.onChange({page, pageSize})
          }}
          delRow={this.props.delRow}
          editRow={this.editRow}
        >
        </CustomOrderListTable>
      </div>
    );
  }
}


export default CustomOrderList;